import { TableGroupLeads } from "./Page/Table/TableGroupLeads";

export const PageGroupLeads = () => {
  return <TableGroupLeads />;
};
